import React from "react";
import { CardTableText, CardTableTextCard } from "src/components";

const AdvertisingCard = (props) => {
    const { content, ...otherProps } = props;

    return (
        <CardTableTextCard {...otherProps}>
            <CardTableText>{content}</CardTableText>
        </CardTableTextCard>
    );
};
export default AdvertisingCard;
